const modules = {
    title: String("Estaciones"),

    // Table view
    moduleManagerTitle: String("Gestión de mis estaciones"),
    moduleNameHeader: String("Nombre"),
    moduleModifyModule: String("Acciones"),
    modulePlotHeader: String("Parcela asignada"),
    moduleCurrentStatus: String("Detalles"),
    moduleEnabledHeader: String("Estado"),
    moduleTypeHeader: String("Tipo"),
    moduleInstallationDateHeader: String("Fecha de instalación"),
    moduleLocationHeader: String("Ubicación"),
    moduleParametersHeader: String("Parámetros"),
    moduleNotPlotAllocated: String("No asignada"),
    
    editButton: String("Modificar"),
    moduleStatusButton: String("Ver"),
    editParamsButton: String("Ver/Actualizar"),
    newModuleButton:    String("Añadir nueva estación"),

    // params
    moduleParamModalTitle: String("Parámetros de la estación {name}"),
    updateParams: String("Actualizar parámetros"),
    restoreParams: String("Reestablecer parámetros"),
    cancelButton: String("Cancelar"),
    // foreach param
    module_post_flow_meter_trees:  String("Árboles post-caudalímetro"),
    module_soil_moisture_max_optimal_region_percentage:  String("Capacidad de campo"),
    module_soil_moisture_min_optimal_region_percentage: String("Punto de marchitamiento permanente"),
    module_soil_moisture_shallow_depth:  String("Sensor humedad en suelo de poca profundidad"),
    module_soil_moisture_intermediate_depth: String("Sensor humedad en suelo de profundidad intermedia"),
    module_soil_moisture_greater_depth: String("Sensor humedad en suelo de mucha produndidad"),
    module_enabled: String("Estado del sensor"),
    module_depth: String("Profundidad del sensor (cm)"),
    module_distance_to_dropper: String("Separación del gotero (cm)"),
    module_max: String("Valor máximo del sensor de humedad en suelo"),
    module_min: String("Valor mínimo del sensor de humedad en suelo"),
    module_post_flow_meter_treesInfoPopover:  String("Árboles post-caudalímetro"),
    module_soil_moisture_max_optimal_region_percentageInfoPopover:  String("Capacidad de campo expresado en porcentage"),
    module_soil_moisture_min_optimal_region_percentageInfoPopover: String("Punto de marchitamiento permanente expresado en porcentage"),
    module_soil_moisture_shallow_depthInfoPopover:  String("Sensor humedad en suelo de poca profundidad"),
    module_soil_moisture_intermediate_depthInfoPopover: String("Sensor humedad en suelo de profundidad intermedia"),
    module_soil_moisture_greater_depthInfoPopover: String("Sensor humedad en suelo de mucha produndidad"),
    module_enabledInfoPopover: String("Estado del sensor"),
    module_depthInfoPopover: String("Profundidad del sensor (cm)"),
    module_distance_to_dropperInfoPopover: String("Separación del gotero (cm)"),
    module_maxInfoPopover: String("Valor máximo del sensor de humedad en suelo"),
    module_minInfoPopover: String("Valor mínimo del sensor de humedad en suelo"),

    // module updater
    moduleModalTitle: String("Módificar datos de la estación"),
    moduleName: String("Nombre de la estación"),
    moduleNameInfoPopover: String("Nombre de la estación"),
    moduleNamePlaceholder: String("Nombre..."),
    modulePlot: String("Parcela asociada"),
    modulePlotInfoPopover: String("Parcela en la que esta montada la estación"),
    modulePlotDefault: String("Selecciona una parcela..."),
    moduleEnable: String("Estado de la estación"),
    moduleEnableInfoPopover: String("Estado de la estación"),
    moduleInstallationDate: String("Fecha de instalación"),
    moduleInstallationDateInfoPopover: String("Fecha en la que se realizó la instalación"),
    update: String("Actualizar"),
    restoreModule: String("Restablecer"),
    errorFieldRequired: String("Este campo es obligatorio"),
    errorInvalidLength: String("El tamaño del campo debe ser mínimo de {length} caracteres"),
    errorNameAlreadyExists: String("Este nombre ya existe."),

    // new module adder
    newModuleModalTitle: String("Formulario de nueva estación"),
    moduleActivationCode: String("Código de la estación o QR"),
    moduleActivationCodePlaceholder: String("Introduce aqui el código de la estación"),
    moduleActivationCodeInfoPopover: String("El código de la estación viene en la etiqueta de identificación de la estación. Así mismo, si en dicha etiqueta hay un código QR, puedes escanearlo para que se introduzca el código automáticamente."),
    moduleLatitudeLongitude: String("Localización de la estación"),
    currentLocationButton: String("Uitilizar la posición actual"),
    moduleLatitudeLongitudeInfoPopover: String("Localización de la estación en grados con el siguiente formato: latitud, longitud"),
    moduleLatitudePlaceholder: String("Latitud"),
    moduleLongitudePlaceholder: String("Longitud"),
    createButton: String("Añadir estación"),
    errorActivationCodeRegex: String("El formato del código introducido es invalido."),
    moduleErrorActivationCodeNotAllowed: String("Este código de activación ya ha sido utilizado."),
    moduleErrorNotFound: String("Este código de activación no pertence a ningúna estación."),
    moduleErrorPlotNotSelected: String("No se ha seleccionado ninguna parcela."),

    // module status
    moduleStatusModalTitle: String("Detalles de la estación"),
    moduleStatusModuleName: String("Nombre de la estación"),
    moduleStatusStatus: String("Estado actual"),
    moduleStatusGood: String("Funcionamiento correcto"),
    moduleStatusWarning: String("Funciona con errores"),
    moduleStatusError: String("No responde"),
    moduleStatusUpdateButton: String("Actualizar"),
    moduleStatusLastMeasureDate: String("Fecha del último envio recibido"),
    moduleStatusMeasureNameHeader: String("Sensor"),
    moduleStatusProcessedHeader: String("Datos procesados"),
    moduleStatusRawHeader: String("Datos crudos"),
    moduleStatus_battery_voltage: String("Tensión de batería"),
    moduleStatus_soil_1_meter: String("Suelo 1"),
    moduleStatus_soil_2_meter: String("Suelo 2"),
    moduleStatus_soil_3_meter: String("Suelo 3"),
    moduleStatus_leaf_meter: String("Humedad en Hoja"),
    moduleStatus_hum_meter: String("Humedad relativa"),
    moduleStatus_temp_meter: String("Temperatura ambiente"),
    moduleStatus_rain_meter: String("Pluviometro"),
    moduleStatus_gauge_meter: String("Caudalimetro"),
    moduleStatusErrorHeader: String("Lista de errores"),
    moduleStatusErrorCode: String("Código"),
    moduleStatusErrorComponent: String("Componente"),
    moduleStatusErrorTimes: String("Veces"),

};

export default modules;